
import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#6358eb',
            light: '#8279f2',
            dark: '#563ba4',
            contrastText: '#e9e4e4',
        },
        secondary: {
            main: '#F9AA33',
        },
        background: {
            default: '#181c23',
            paper: '#22262d',
            paperSecondary: '#505866',
        },
        text: {
            primary: '#e9e4e4',
            secondary: '#c5c5cb',
        },
        chart: [
            '#6358eb', // roxo (primary)
            '#F9AA33', // laranja (secondary)
            '#14B8A6', // teal
            '#22C55E', // verde
            '#EC4899', // rosa
            '#F59E0B', // âmbar
            '#3B82F6', // azul
            '#EF4444', // vermelho
        ],
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: '#e9e4e4',
                },
            },
        },
        
        MuiAvatar: {
            styleOverrides: {
                root: {
                    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                },
            },
        },
    },
});
